let globalCounter = 0;
const PREFIX = 'bs-infosite-auto-';

export function createId() {
	return PREFIX + globalCounter++;
}
